import _debug from 'debug';
import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { TopBar } from 'containers';
import { connect } from 'react-redux';
import NotificationSystem from 'react-notification-system';
import * as appActionsCreators from 'state/modules/app';
import * as manageActionsCreators from 'state/modules/manage';
import styles from './App.css';


const debug = _debug('app:App');
const style = {
  Wrapper: {
    display: 'flex',
    justifyContent: 'center'
  },
  Containers: {
    DefaultStyle: {
      width: 420
    },
    tc: { // Override the tc(top center)
      top: '1.956em'
    },
  },
  NotificationItem: { // Override the notification item
    DefaultStyle: {
      fontSize: '1.0rem'
    },
    success: { // Override the success notification item
      backgroundColor: '#64be88',
      borderTop: 'none',
      color: '#eeeeee'
    }
  },
  Dismiss: { // Override the Dismiss item
    DefaultStyle: {
      fontFamily: 'Arial',
      fontSize: '2.0625rem',
      backgroundColor: 'transparent',
      borderRadius: 'inherit',
      fontWeight: 'inherit',
      top: '0.3em',
    }
  }
};

class App extends Component {

  static propTypes = {
    children: PropTypes.node,
    progressBar: PropTypes.shape({}),
    updateProgressBar: PropTypes.func,
    dataIsLoading: PropTypes.bool,
    fetchManageCampaignData: PropTypes.func,
    fetchUserLicense: PropTypes.func
  }

  constructor(props) {
    super(props);
    debug('In App Component');
    this.state = {
      notificationSystem: null,
    };
  }

  componentWillMount() {
    if (__MANAGE__) {
      this.props.fetchManageCampaignData().then(() => {
        this.props.fetchUserLicense();
      });
    }
  }

  componentDidMount() {
    const isIE = false || !!document.documentMode;
    const isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && !navigator.userAgent.match('CriOS');
    if (!(isIE || isSafari)) {
      if (this.notificationSystem) {
        this.notificationSystem.addNotification({
          message: 'This application is best viewed in IE 11+ or Safari 9+',
          level: 'success',
          position: 'tc',
          autoDismiss: 5
        });
      }
    }
  }

  render() {
    /*
    * Helper function for React Children, which will allow us to pass the data as
    * Prop to child components which are getting loaded by the router.
    */
    const children = React.Children.map(this.props.children, child => (
        React.cloneElement(child, {
          updateProgressBar: this.props.updateProgressBar
        })
      )
    );
    return (
      <div className={styles.flexContainer}>
        {!__MANAGE__ &&
        <NotificationSystem ref={ref => (this.notificationSystem = ref)} style={style} />}
        {!__MANAGE__ && <TopBar
          progressBar={this.props.progressBar}
          dataIsLoading={this.props.dataIsLoading}
        />
        }
        {children}
      </div>
    );
  }
}


const mapStateToProps = state => ({
  progressBar: !__MANAGE__ && state.app.progressBar,
  dataIsLoading: !__MANAGE__ && state.assign && state.assign.isLoading,
});

/*
Following Actions are being mapped to props
  1) updateProgressBar
*/

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    Object.assign(
      {},
      appActionsCreators,
      manageActionsCreators
    ), dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/App.js